<template>
  <div class="opdrachtPopUp">
    <svg @click="close()" class="closePopUp" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" /></svg>
    <!-- 
          Contactgegevens sectie
         -->
    <div class="contactgegevensContainer">
      <transition-group name="pfSlideIn">
        <div key="1" @click="picturePop = false" v-if="picturePop" class="zoomedPicture">
          <img v-if="selectedUser.profilePictureURL" :src="selectedUser.profilePictureURL" />
          <img v-if="!selectedUser.profilePictureURL" src="../../../../assets/noProfilePicture.png" alt="" />
        </div>
      </transition-group>
      <div class="contactgegevensTop">
        <img @click="picturePop = !picturePop" v-if="selectedUser.profilePictureURL" :src="selectedUser.profilePictureURL" alt="" />
        <img v-if="!selectedUser.profilePictureURL" src="../../../../assets/noProfilePicture.png" alt="" />
        <div>
          <h4 class="capitalize" v-if="selectedUser.voornaam">{{ selectedUser.voornaam.toLowerCase() || "" }}</h4>
          <h4 class="capitalize" v-if="selectedUser.achternaam">{{ selectedUser.achternaam.toLowerCase() || "" }}</h4>
        </div>
      </div>
      <div class="contactWrapper">
        <a target="_blank" :href="`mailto:${selectedUser.email}`">
          <div class="contactGegevens">
            <i class="far fa-envelope-open"></i>
            <span>{{ selectedUser.email }}</span>
          </div>
        </a>
        <a :href="`tel:${selectedUser.telefoon}`">
          <div class="contactGegevens">
            <i class="far fa-phone-alt"></i>
            <span>{{ selectedUser.telefoon }}</span>
          </div>
        </a>
      </div>
    </div>
    <!-- 
          NAW gegevens sectie
         -->
    <div class="contentContainer">
      <div v-if="opdrachtenOfTekenaar.length" style="margin-bottom: 0.5rem" class="ag_contentTitle"><i class="fas fa-user-edit"></i>Opdrachten van deze tekenaar</div>

      <div class="opdracht" v-for="(opdracht, index) in opdrachtenOfTekenaar" :key="index" @click="openOpdracht(opdracht.id)">
        <div>
          <span style="font-weight: 600">
            <span style="opacity: 0.5">CDT.{{ new Date(opdracht.metadata.createdAt.toDate()).getFullYear() }}.{{ new Date(opdracht.metadata.createdAt.toDate()).getMonth() + 1 }}.</span>{{ opdracht.metadata.opdrachtNummer }}
          </span>
          <span style="margin-left: 0.2rem"> | {{ opdracht.opdrachtgever.bedrijfsnaam }} </span>
        </div>
        <VoortgangsBalk style="max-width: 40%" :opdracht="opdracht" />
      </div>

      <br v-if="opdrachtenOfTekenaar.length" />

      <div class="contentTop" @click="openSlideForCategorieNAW = !openSlideForCategorieNAW">
        <div class="ag_contentTitle"><i class="fas fa-user-edit"></i>NAW Gegevens</div>
        <i v-if="!openSlideForCategorieNAW" class="fas fa-chevron-down"></i>
        <i v-if="openSlideForCategorieNAW" class="fas fa-chevron-up"></i>
      </div>
      <div class="wrapperForSlide" :class="{ wrapperOpen: openSlideForCategorieNAW }">
        <div class="ag_content">
          <div class="ag_content_Left">
            <span><strong> Beschikbaarheid: </strong> {{ selectedUser.beschikbaarheidInUrenPerWeek }} uur per week</span>
            <span><strong> Leeftijd:</strong> {{ getAge(selectedUser.geboortedatum) }}</span>
            <span><strong>Hoogste opleiding:</strong> {{ selectedUser.hoogstGenotenOpleiding }}</span>
          </div>
          <div class="ag_content_Right">
            <span v-if="selectedUser.beschikbaar"><strong>Beschikbaar:</strong> Ja</span>
            <span v-if="!selectedUser.beschikbaar"><strong>Beschikbaar:</strong> Nee</span>
            <span><strong> Aantal jaar ervaring:</strong> {{ selectedUser.aantalJaarErvaring }}</span>
            <span class="capitalize" v-if="selectedUser.plaats"><strong> Woonplaats:</strong> {{ selectedUser.plaats.toLowerCase() }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 
          Bedrijfsgegevens
         -->
    <div class="contentContainer">
      <div class="contentTop" @click="openSlideForCategorieBG = !openSlideForCategorieBG">
        <div class="ag_contentTitle">
          <span>
            <i class="far fa-building"></i>
            Bedrijfsgegevens
          </span>
        </div>
        <i v-if="!openSlideForCategorieBG" class="fas fa-chevron-down"></i>
        <i v-if="openSlideForCategorieBG" class="fas fa-chevron-up"></i>
      </div>
      <div class="wrapperForSlide" :class="{ wrapperOpen: openSlideForCategorieBG }">
        <div class="ag_content">
          <div class="ag_content_Left">
            <span><strong>Bedrijfsnaam:</strong> {{ selectedUser.bedrijfsnaam }}</span>
            <span><strong>KVK Nummer:</strong> {{ selectedUser.kvknummer }}</span>
            <a :href="`https://${selectedUser.website}`" target="_blank">
              <span v-if="selectedUser.website"><strong>Website:</strong> {{ selectedUser.website }}</span></a
            >
          </div>
          <div class="ag_content_Right">
            <span><strong>DBT-Nummer:</strong> 20.<span v-for="(x, index) in 4 - `${btwNummer}`.length" :key="index">0</span>{{ btwNummer }}</span>
            <span><strong>Iban:</strong> {{ selectedUser.iban }}</span>
            <span><strong>BTW-Nummer:</strong> {{ selectedUser.btwnummer }}</span>
            <span><strong>Aantal jaar zelfstandig:</strong> {{ selectedUser.aantalJaarZelfstandig }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 
          WerkProfiel sectie
         -->
    <!-- <div class="werkProfiel"> -->
    <div class="contentContainer">
      <div @click="openSlideForCategorieWP = !openSlideForCategorieWP" class="contentTop">
        <span class="ag_contentTitle"><i class="fal fa-id-card"></i>Werkprofiel</span>
        <i v-if="!openSlideForCategorieWP" class="fas fa-chevron-down"></i>
        <i v-if="openSlideForCategorieWP" class="fas fa-chevron-up"></i>
      </div>
      <div>
        <div class="wrapperForSlide" :class="{ wrapperOpen: openSlideForCategorieWP }">
          <div class="wp_Item">
            <span><strong> Disciplines</strong></span>
            <div class="wp_ItemWrapper">
              <span class="disciplines capitalize" :style="dynamicBackgroundColor(d)" v-for="(d, index) in selectedUser.disciplines" :key="index">{{ d }}</span>
              <span v-if="!selectedUser.disciplines || selectedUser.disciplines.length < 1" class="nietIngevuld">Niet ingevuld</span>
            </div>
          </div>
          <div class="wp_Item">
            <span><strong>Berekeningen</strong> </span>
            <div class="wp_ItemWrapper">
              <span class="capitalize" v-for="b in selectedUser.berekeningen" :key="b">
                {{ b }}
              </span>
              <span v-if="(selectedUser.berekeningen && selectedUser.berekeningen.length < 1) || !selectedUser.berekeningen" class="nietIngevuld">Niet ingevuld</span>
            </div>
          </div>
          <div class="wp_Item">
            <span><strong> Nen2580</strong></span>
            <span v-for="n in selectedUser.nen2580Werkzaamheden" :key="n">{{ n }}</span>
            <span v-if="(selectedUser.nen2580Werkzaamheden && selectedUser.nen2580Werkzaamheden.length < 1) || !selectedUser.nen2580Werkzaamheden" class="nietIngevuld">Niet ingevuld</span>
          </div>
          <div class="wp_Item">
            <span><strong> Tekenprogramma's</strong></span>
            <div class="wp_ItemWrapper">
              <span class="capitalize" v-for="t in selectedUser.tekenprogrammas" :key="t">{{ t }}</span>
              <span v-if="!selectedUser.tekenprogrammas || selectedUser.tekenprogrammas.length < 1" class="nietIngevuld">Niet ingevuld</span>
            </div>
          </div>
          <div class="wp_Item">
            <span><strong> Aanvullende Applicaties</strong></span>
            <div class="wp_ItemWrapper">
              <span class="capitalize" v-for="a in selectedUser.aanvullendeApplicaties" :key="a">{{ a }}</span>
              <span v-if="!selectedUser.aanvullendeApplicaties || selectedUser.aanvullendeApplicaties.length < 1" class="nietIngevuld">Niet ingevuld</span>
            </div>
          </div>

          <div class="wp_Item">
            <span><strong> Hoogste opleiding </strong></span>
            <p>{{ selectedUser.hoogstGenotenOpleiding }}</p>
            <span v-if="!selectedUser.hoogstGenotenOpleiding" class="nietIngevuld">Niet ingevuld</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 
      Voorkeuren
     -->
    <div class="contentContainer">
      <div @click="openSlideForCategorieVK = !openSlideForCategorieVK" class="contentTop">
        <span class="ag_contentTitle">
          <i class="far fa-heart"></i>
          Voorkeuren
        </span>
        <i v-if="!openSlideForCategorieVK" class="fas fa-chevron-down"></i>
        <i v-if="openSlideForCategorieVK" class="fas fa-chevron-up"></i>
      </div>
      <div class="wrapperForSlide" :class="{ wrapperOpen: openSlideForCategorieVK }">
        <div class="wp_Item">
          <span><strong>Werkgebied</strong></span>
          <div class="wp_ItemWrapper">
            <span v-for="w in selectedUser.werkgebied" :key="w" class="capitalize">
              {{ w }}
            </span>
            <span v-if="!selectedUser.werkgebied || selectedUser.werkgebied.length < 1" class="nietIngevuld">Niet ingevuld</span>
          </div>
        </div>
        <div class="wp_Item">
          <span><strong>Werkplek</strong></span>
          <div class="wp_ItemWrapper">
            <span v-for="p in selectedUser.werkplek" :key="p" class="capitalize">
              {{ p }}
            </span>
            <span v-if="!selectedUser.werkplek || selectedUser.werkplek.length < 1" class="nietIngevuld">Niet ingevuld</span>
          </div>
        </div>
        <div class="wp_Item">
          <span><strong>Type Opdrachten</strong></span>
          <div class="wp_ItemWrapper">
            <span v-for="t in selectedUser.voorkeurTypeOpdrachten" :key="t">{{ t }}</span>
            <span v-if="!selectedUser.voorkeurTypeOpdrachten || selectedUser.voorkeurTypeOpdrachten.length < 1" class="nietIngevuld">Niet ingevuld</span>
          </div>
        </div>
        <div class="wp_Item">
          <span><strong>Particuliere opdrachten</strong></span>
          <span v-if="selectedUser.openVoorParticulierWerk">Ja</span>
          <span v-if="selectedUser.openVoorParticulierWerk === false">Nee</span>
        </div>
        <div class="wp_Item">
          <span><strong> Ambities</strong></span>
          <div class="wp_ItemWrapper">
            <p>{{ selectedUser.ambities }}</p>
            <span v-if="!selectedUser.ambities" class="nietIngevuld">Niet ingevuld</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 

      Kwaliteiten

     -->
    <div class="contentContainer">
      <div @click="openSlideForCategorieKW = !openSlideForCategorieKW" class="contentTop">
        <span class="ag_contentTitle"> <i class="fad fa-stars"></i>Kwaliteiten </span>
        <i v-if="!openSlideForCategorieKW" class="fas fa-chevron-down"></i>
        <i v-if="openSlideForCategorieKW" class="fas fa-chevron-up"></i>
      </div>
      <div class="wrapperForSlide" :class="{ wrapperOpen: openSlideForCategorieKW }">
        <div class="wp_Item column">
          <span><strong>Competenties en persoonlijke eigenschappen</strong></span>
          <div class="wp_ItemWrapper">
            <span v-for="k in selectedUser.kwaliteiten" :key="k">{{ k }}</span>
            <span v-if="!selectedUser.kwaliteiten || selectedUser.kwaliteiten.length < 1" class="nietIngevuld">Niet ingevuld</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Pools -->
    <div class="contentContainer">
      <div @click="openSlideForCategoriePools = !openSlideForCategoriePools" class="contentTop">
        <span class="ag_contentTitle"> <i class="fad fa-file"></i>Pools ({{ pools.length }})</span>
        <i v-if="!openSlideForCategoriePools" class="fas fa-chevron-down"></i>
        <i v-if="openSlideForCategoriePools" class="fas fa-chevron-up"></i>
      </div>
      <div class="wrapperForSlide" :class="{ wrapperOpen: openSlideForCategoriePools }">
        <br />
        <div v-if="!pools?.length">
          Deze tekenaar is niet ingeschreven in een pool...
          <br />
          <button @click="addToPool('fVYDecMiy7Vhcjh1cwgP')">
            <div class="button-icon">
              <i class="far fa-plus-circle"></i>
            </div>
            <div class="button-text">Voeg toe aan Veolia Pool</div>
          </button>
        </div>
        <div v-else-if="pools[0] === 'fVYDecMiy7Vhcjh1cwgP'">
          Deze tekenaar is ingeschreven in de Veolia Pool
          <br />
          <button @click="removeFromPool('fVYDecMiy7Vhcjh1cwgP')">
            <div class="button-icon">
              <i class="far fa-trash-alt"></i>
            </div>
            <div class="button-text">Verwijder uit Veolia Pool</div>
          </button>
          <button></button>
        </div>
      </div>
    </div>

    <!-- Documenten -->
    <div class="contentContainer">
      <div @click="openSlideForCategorieDocuments = !openSlideForCategorieDocuments" class="contentTop">
        <span class="ag_contentTitle"> <i class="fad fa-file"></i>Documenten</span>
        <i v-if="!openSlideForCategorieDocuments" class="fas fa-chevron-down"></i>
        <i v-if="openSlideForCategorieDocuments" class="fas fa-chevron-up"></i>
      </div>
      <div class="wrapperForSlide" :class="{ wrapperOpen: openSlideForCategorieDocuments }">
        <upload-file-to-user :user-id="$store.state.selectedUserProfileId" :files="files" />
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "../../../../firebase"
import firebase from "firebase"

import { getAge } from "@/assets/helpers"
import store from "../../../../store"
import UploadFileToUser from "../../../ui-elements/UploadFileToUser.vue"
import VoortgangsBalk from "@/components/v2/voortgangsBalk"

export default {
  setup() {
    const openOpdracht = (id) => store.commit("opdracht/setId", id)

    return { openOpdracht }
  },
  data() {
    return {
      btwNummer: "",
      disciplines: ["bouwkunde", "werktuigbouwkunde", "installatietechniek", "elektrotechniek", "brandpreventie", "huisvesting", "plattegronden", "concepten -3d print"],
      picturePop: false,
      openSlideForCategorieNAW: true,
      openSlideForCategorieBG: true,
      openSlideForCategorieWP: true,
      openSlideForCategorieVK: true,
      openSlideForCategorieKW: true,
      openSlideForCategoriePools: true,
      openSlideForCategorieDocuments: true,
      colors: [
        "#575fcf",
        "#ef5777",
        "#4bcffa",
        "#4cd137",
        "#1e272e",
        "#ff3f34",
        "#485460",
        "#ffc048",
        "#fff200",
        "#ffb8b8", //Pink
      ],
    }
  },
  watch: {
    selectedUserChange: {
      immediate: true,
      handler() {
        fetch(`https://us-central1-cdt-dev-94ea4.cloudfunctions.net/debiteuren-api/getdebiteurnummer?id=${store.state.selectedUserProfileId}`).then((data) => {
          data.json().then((result) => {
            this.btwNummer = result.debiteurNummer
          })
        })
      },
    },
  },
  methods: {
    removeFromPool(poolIdToRemove) {
      db.collection("users")
        .doc(store.state.selectedUserProfileId)
        .update({
          pools: this.pools.filter((poolId) => poolId !== poolIdToRemove),
        })
    },
    addToPool(poolId) {
      console.log(poolId)
      db.collection("users")
        .doc(store.state.selectedUserProfileId)
        .update({
          pools: firebase.firestore.FieldValue.arrayUnion(poolId),
        })
    },
    close() {
      return (store.state.selectedUserProfileId = null)
    },
    getAge() {
      return getAge()
    },
    dynamicBackgroundColor(d) {
      const index = this.disciplines.indexOf(d)
      const color = this.colors[index]
      return `background-color: ${color}`
    },
  },
  computed: {
    opdrachtenOfTekenaar() {
      const opdrachten = store.state.opdrachten

      return opdrachten.filter((opdracht) => opdracht.afhandeling?.tekenaar === store.state.selectedUserProfileId)
    },

    selectedUserChange() {
      return JSON.stringify(this.selectedUser)
    },
    files() {
      return store.state.userAccounts.find((e) => e.id === store.state.selectedUserProfileId)?.files
    },
    pools() {
      return store.state.userAccounts.find((e) => e.id === store.state.selectedUserProfileId)?.pools || []
    },
    tekenaars() {
      return store.state.tekenaars
    },

    selectedUser() {
      return store.state.userAccounts.find((e) => e.id === store.state.selectedUserProfileId)?.userProfile
    },
  },
  components: { UploadFileToUser, VoortgangsBalk },
}
</script>

<style lang="sass" scoped>
@import '@/utilities/variables.sass'
@import '@/utilities/animations.sass'


button
  &:hover
    opacity: 0.9
  cursor: pointer
  transition: .2s
  display: flex
  align-items: stretch
  color: white
  outline: none
  font-weight: 500
  font-family: 'manrope'
  border: none
  border-radius: 0.4rem
  margin-top: 0.4rem
  padding: 0
  overflow: hidden
  height: 100%
  .button-icon
    display: flex
    align-items: center
    justify-content: center
    background-color: #333
    width: 2rem
    font-size: 15px
    height: 2rem
    flex-grow: 1
  .button-text
    background-color: black
    padding: 0.4rem 0.6rem

.opdracht
  display: flex
  justify-content: space-between
  align-items: center
  transition: .2s
  width: 100%
  padding: 0.5rem 0
  border-radius: 8px
  cursor: pointer
  user-select: none
  &:hover
    padding: 0.5rem
    background-color: rgba(0, 0, 0, 0.06)


.opdrachtPopUp
  position: fixed
  padding-bottom: 80px
  top: 0
  right: 0
  bottom: 0
  left: 45vw
  background-color: white
  overflow: hidden
  overflow-y: scroll
  z-index: 10
  box-shadow: 0 0 100px 200px rgba(0, 0, 0, 0.1)
  .closePopUp
    // font-size: 24px
    position: absolute
    top: 10px
    right: 10px
    width: 40px
    max-height: 40px
    color: $lightGrey
    fill: $lightGrey
    padding: 10px
    cursor: pointer
    transition: .2s
    &:hover
      transform: scale(1.1)
  .contactgegevensContainer
    border-bottom: 1px solid rgba(0, 0, 0, 0.2)
    padding: 40px 40px 20px 40px
    background-color: $darkGrey
    .zoomedPicture
      position: fixed
      height: 400px
      width: 400px
      background-color: $darkGrey
      border-radius: 14px
      overflow: hidden
      z-index: 7
      cursor: pointer
      img
        min-height: 400px
        width: 400px
    .contactgegevensTop
      text-transform: capitalize
      display: flex
      align-items: center
      color: white
      img
        object-fit: cover
        margin-right: 14px
        max-height: 60px
        min-height: 60px
        max-width: 60px
        min-width: 60px
        border-radius: 100%
        cursor: pointer
        transition: .3s
        z-index: 1
        &:hover
          transform: scale(1.05)

    .contactWrapper
      background-color: $lightGrey
      display: flex
      padding: 20px
      justify-content: space-between
      border-radius: 4px
      margin-top: 20px
      font-weight: 600
      a
        color: black
        text-decoration: none
      .contactGegevens
        transition: .2s
        i
          margin-right: 8px
          color: black
          transition: .2s
        &:hover
          color: $blue
          i
            color: $blue


  .contentContainer
    padding: $horizontalContentPadding
    .contentTop
      display: flex
      justify-content: space-between
      cursor: pointer
    .ag_contentTitle
      font-weight: 600
      color: $blue
      i
        margin-right: 4px
    .wrapperForSlide
      max-height: 0px
      overflow: hidden
      transition: .3s
    .wrapperOpen
      max-height: 600px
    .ag_content
      padding-top: 14px
      display: flex
      justify-content: space-between
      .ag_content_Left, .ag_content_Right
        display: flex
        flex-direction: column
        a
          margin-left: 4px
          text-decoration: none
          color: black
      .ag_content_Right
        align-items: flex-start

    .wp_Item
      display: flex
      justify-content: space-between
      align-items: flex-start
      border-bottom: 1px solid rgba(0, 0, 0, 0.1)
      padding: 14px 0 14px 0
      .wp_ItemWrapper
        margin-left: 14px
        display: flex
        flex-wrap: wrap
        span
          background-color: $lightGrey
          color: black
          padding: 4px 10px
          border-radius: 20px
          margin: 4px
          font-size: 14px
          transition: .2s
        .disciplines
          color: white
          font-weight: 500

  .nietIngevuld
    color: $red !important
    background-color: $lightRed !important
    padding: 4px 10px !important
    border-radius: 20px !important
    font-size: 14px
  .column
    flex-direction: column
</style>
